import { createTheme } from "@mui/material/styles";

export const getTheme = (color) => {
  const colors = {
    black: {
      palette: {
        primary: { main: "#000000" },
        secondary: { main: "#333333" },
        background: { default: "#121212", paper: "#1e1e1e" },
        text: { primary: "#ffffff", secondary: "#bbbbbb" },
      },
      components: {
        MuiButton: {
          styleOverrides: {
            outlined: {
              color: "#ffffff",
              borderColor: "#ffffff",
              "&:hover": {
                borderColor: "#bbbbbb",
              },
            },
            contained: {
              color: "#ffffff",
            },
            text: {
              color: "#ffffff",
            },
          },
        },
        MuiIconButton: {
          styleOverrides: {
            root: {
              color: "#ffffff",
              "&:hover": {
                color: "#bbbbbb",
              },
            },
          },
        },
        MuiTypography: {
          styleOverrides: {
            root: {
              color: "#ffffff",
            },
          },
        },
        MuiListItemIcon: {
          styleOverrides: {
            root: {
              color: "#ffffff",
            },
          },
        },
      },
    },
  };

  const commonComponents = {
    MuiButton: {
      styleOverrides: {
        outlined: {
          "&:hover": {
            borderColor: "#666666",
          },
        },
      },
    },
    MuiIconButton: {
      styleOverrides: {
        root: {
          "&:hover": {
            color: "#666666",
          },
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          fontWeight: 400,
        },
      },
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          minWidth: 40,
        },
      },
    },
  };

  return createTheme({
    ...(colors[color] || colors.blue),
    components: {
      ...commonComponents,
      ...(colors[color]?.components || {}),
    },
  });
};
